import classnames from "classnames";

import svgSymbolDefinition from "src/assets/icons/symbol-defs.svg";

import styles from "./Icon.module.css";

interface IconProps {
  name:
    | "arrow-down"
    | "arrow-left"
    | "arrow-right"
    | "arrow-up"
    | "back-arrow"
    | "check-mark"
    | "close-modal"
    | "eye"
    | "eye-blocked"
    | "facebook"
    | "linkedin"
    | "search"
    | "times"
    | "trash"
    | "x-mark"
    | "plus"
    | "name"
    | "duplicate"
    | "add"
    | "log-out"
    | "menu-open"
    | "menu-close"
    | "user"
    | "accept"
    | "decline"
    | "first-step"
    | "second-step"
    | "third-step"
    | "first-step-mob"
    | "second-step-mob"
    | "third-step-mob"
    | "systems-list"
    | "rectangle-h"
    | "help"
    | "options"
    | "filter"
    | "remove-filter"
    | "calendar"
    | "help-circle"
    | "download";
  className?: string;
}

export const Icon = ({ name, className }: IconProps) => {
  return (
    <svg className={classnames(styles.icon, className)}>
      <use xlinkHref={`${svgSymbolDefinition}#icon-${name}`}></use>
    </svg>
  );
};
